<div class="page">
  <div class="content">
    <div class="main">
      <div class="logo">
        <img src="./assets/images/logo-dark.svg" loading="lazy" height="32px" alt="sepidz logo" />
      </div>
      <div class="contactinfo">
        <section class="infobox">
          <div class="boxinfo">
            <i class="icon-call-o contacticon"></i>
            <span>021-91002030</span>
          </div>
          <div class="boxinfo">
            <i class="icon-globe contacticon"></i>
            <span>www.sepidz.com</span>
          </div>
          <div class="boxinfo">
            <i class="icon-location_on-o contacticon"></i>
            <span class="text-text-right"> {{ "ClientApp.FrontOffice.Review.Dashboard.Address" | translate }} </span>
          </div>
        </section>
        <section>
          <div class="boxinfo">
            <i class="icon-person_outline-o contacticon"></i>
            <span> {{ "ClientApp.FrontOffice.Review.Dashboard.CustomerCode" | translate }}</span>
            <span>
              {{ currentInformation?.LockNumber }}
            </span>
          </div>

          <div class="boxinfo">
            <i class="icon-dynamic_feed-F contacticon"></i>
            <span>
              <span> {{ "ClientApp.FrontOffice.Review.Dashboard.SaftWareVersion" | translate }}</span>
            </span>
            <span>
              {{ currentInformation?.ProductVersion }}
            </span>
          </div>
        </section>
      </div>
    </div>
    <div class="footer">
      <ssg-button [label]="'ClientApp.FrontOffice.Review.Dashboard.closeModal' | translate" (click)="closeModal()"></ssg-button>
      <a target="_blank" href="https://sc.sepidz.com">{{ "ClientApp.FrontOffice.Review.Dashboard.RemoteCommunication" | translate }}</a>
    </div>
  </div>
  <div class="leftbox">
    <i class="icon-headset_mic-F"></i>
    <div class="title">
      {{ "ClientApp.FrontOffice.Review.Dashboard.Calling" | translate }}
    </div>
  </div>
</div>
